import { Tooltip, TooltipContent, TooltipTrigger, TooltipProvider } from '@/components/ui/tooltip';

type Props = {
  triggerNode: React.ReactNode;
};

const ReviewRequestTerminationTooltip = ({ triggerNode }: Props) => {
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>{triggerNode}</TooltipTrigger>
        <TooltipContent
          side="bottom"
          align="center"
          className="max-w-[220px] bg-white text-sm text-popover-foreground shadow-md border-border"
        >
          You don’t have the necessary permissions to perform this action.
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default ReviewRequestTerminationTooltip;
